import { render, staticRenderFns } from "./rmzxbomlll.vue?vue&type=template&id=1d798913&scoped=true&"
import script from "./rmzxbomlll.vue?vue&type=script&lang=js&"
export * from "./rmzxbomlll.vue?vue&type=script&lang=js&"
import style0 from "./rmzxbomlll.vue?vue&type=style&index=0&id=1d798913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d798913",
  null
  
)

export default component.exports